// @flow
import React from "react";
import classNames from "classnames";
import { localize } from "redux-i18n";
import "./loader.style.scss";

type Props = $Exact<{
  loadingText?: string,
  inline?: boolean,
  textInline?: boolean,
  transparent?: boolean,
  className?: string,
  ...PropsFromLocalize,
}>;

function Loader(props: Props) {
  const loadingText = props.loadingText;
  return (
    <div
      className={classNames("loader", props.className, {
        inline: props.hasOwnProperty("inline"),
        textinline: props.textInline,
        transparent: props.transparent,
      })}
    >
      <div className={"loading-text"}>{props.loadingText || props.t("ONE_MOMENT_PLEASE")}</div>
      <div className="anim-container">
        <div className="dot col1" />
        <div className="dot col2" />
        <div className="dot col3" />
        <div className="dot col4" />
      </div>
    </div>
  );
}

export default localize()(Loader);
